import { getAffiliateGoods } from './getAffiliateGoods';
import { postAffiliateLinksAccessLogs } from './postAffiliateLinksAccessLogs';

export const affiliateService = {
  getAffiliateGoods,
  postAffiliateLinksAccessLogs,
};
